export default {
	sampleTestColorCode(sample_tests, type, all = false){
		let filter = sample_tests.filter(test => test.sample_test_type_uuid === type.uuid);
		let red,gold,green,blue,purple;
		if(!all){
			red = filter.some(test => test.mass.value_1 < 0.00000001) ? 'error ' : false;
			gold = filter.some(test => test.mass.value_1 > 0) ? 'amber black--text ' : false;
			green = filter.some(test => test.sample_test_analytes && test.sample_test_analytes.length > 0) ? "success white--text " : false;
			blue = filter.some(test => test.complete) ? "blue white--text " : false;
			purple = filter.some(test => test.retest && !(test.sample_test_analytes ? test.sample_test_analytes.length > 0 : test.sample_test_analytes)) ? "purple white--text " : false;
		}else{
			red = filter.every(test => test.mass.value_1 < 0.00000001) ? 'error ' : false;
			gold = filter.every(test => test.mass.value_1 > 0) ? 'amber black--text ' : false;
			green = filter.every(test => test.sample_test_analytes.length > 0) ? "success white--text " : false;
			blue = filter.every(test => test.complete) ? "blue white--text " : false;
			purple = filter.every(test => test.retest && !(test.sample_test_analytes ? test.sample_test_analytes.length > 0 : test.sample_test_analytes)) ? "purple white--text " : false;
			
		}
		if(purple){return purple;}
		if(blue){return blue;}
		if(green){return green;}
		if(gold){return gold;}
		if(red){return red;}
		return '';
	},
	sampleRequiredTestColor(required_tests, type){
		let filter = required_tests.filter(test => test.sample_test_type_uuid === type.uuid);
		if(filter.length > 1){
			filter.sort((a,b) => {
				return a.priority - b.priority;
			})
		}
		if(filter.length > 0){
			return filter[0].color;
		}
		return ''
	},
	sampleTestStatus(required_tests, type){
		let filter = required_tests.filter(test => test.sample_test_type_uuid === type.uuid);
		if(filter.length > 1){
			filter.sort((a,b) => {
				return a.priority - b.priority;
			})
		}
		if(filter.length > 0){
			const color = filter[0].color;
			return color.includes('error') ? 'Awaiting Prep' :
				color.includes('blue-grey') ? 'Test Canceled' :
					color.includes('blue') ? 'Approved' :
						color.includes('success') ? 'Awaiting QA' :
							color.includes('purple') ? 'Awaiting Retests' :
								color.includes('amber') ? 'Awaiting Analytes' : 'Not Required';
		}
		return 'Not Required'
	},
	testCount(sample_tests, type, retest_only = false){
		if(retest_only){
			return sample_tests.filter(test => test.sample_test_type_uuid === type && test.retest).length;
		}
		return sample_tests.filter(test => test.sample_test_type_uuid === type).length;
	},
}
